import { z } from 'zod';

import { ulidSchema } from '../primitives';
import {
  restaurantResponseEntitySchema,
  reviewAdminSchema,
  reviewPublicSchema,
  reviewStarsSchema,
} from '../review';

export const submitReviewRequestSchema = z.object({
  stars: reviewStarsSchema,
  body: z.string().max(2000).optional(),
});
export type SubmitReviewRequest = z.infer<typeof submitReviewRequestSchema>;

export const editReviewRequestSchema = z.object({
  stars: reviewStarsSchema.optional(),
  body: z.string().max(2000).optional(),
});
export type EditReviewRequest = z.infer<typeof editReviewRequestSchema>;

export const restaurantResponseRequestSchema = z.object({
  body: z.string().min(1).max(2000),
});
export type RestaurantResponseRequest = z.infer<typeof restaurantResponseRequestSchema>;

export const flagReviewRequestSchema = z.object({
  reason: z.string().min(10).max(1000),
});
export type FlagReviewRequest = z.infer<typeof flagReviewRequestSchema>;

export const adminHideReviewRequestSchema = z.object({
  hiddenReason: z.string().min(10).max(1000),
});
export type AdminHideReviewRequest = z.infer<typeof adminHideReviewRequestSchema>;

export const publicReviewsListQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(50).default(20),
  cursor: z.string().min(1).optional(),
});
export type PublicReviewsListQuery = z.infer<typeof publicReviewsListQuerySchema>;

export const publicReviewsListResponseSchema = z.object({
  items: z.array(reviewPublicSchema),
  cursor: z.string().min(1).optional(),
});
export type PublicReviewsListResponse = z.infer<typeof publicReviewsListResponseSchema>;

export const flaggedReviewsListResponseSchema = z.object({
  items: z.array(reviewAdminSchema),
  cursor: z.string().min(1).optional(),
});
export type FlaggedReviewsListResponse = z.infer<typeof flaggedReviewsListResponseSchema>;

export const reviewFlagResponseSchema = z.object({
  reviewId: ulidSchema,
});
export type ReviewFlagResponse = z.infer<typeof reviewFlagResponseSchema>;

export const adminReviewMutationResponseSchema = z.object({
  reviewId: ulidSchema,
  status: z.enum(['HIDDEN_BY_ADMIN', 'PUBLISHED']),
});
export type AdminReviewMutationResponse = z.infer<typeof adminReviewMutationResponseSchema>;

export const restaurantReviewResponseMutationResponseSchema = restaurantResponseEntitySchema;
export type RestaurantReviewResponseMutationResponse = z.infer<
  typeof restaurantReviewResponseMutationResponseSchema
>;

export const reviewPathParamsSchema = z.object({
  reviewId: ulidSchema,
});
export type ReviewPathParams = z.infer<typeof reviewPathParamsSchema>;

export const restaurantReviewPathParamsSchema = z.object({
  id: ulidSchema,
  reviewId: ulidSchema,
});
export type RestaurantReviewPathParams = z.infer<typeof restaurantReviewPathParamsSchema>;
